
import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage'; 

const Layout = () => import('OL/views/Layout.vue');
const Login = () => import('OL/views/Login/Login.vue');
const ChatAnonymity = () => import('OL/views/ChatAnonymity/ChatAnonymity.vue');
const Home = () => import('OL/views/Home/Home.vue');
const DownLoadCenterAndAFK = () => import('OL/views/DownloadCenter/DownLoadCenterAndAFK.vue');
const Timeout = () => import('OL/views/ErrorHandle/Timeout.vue');
const Offline = () => import('OL/views/ErrorHandle/Offline.vue');
const ErrorMsg = () => import('OL/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('OL/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('OL/views/Register/Register.LinkFailure.vue');
const Register = () => import('OL/views/Register/Register.vue');   
const Bet = () => import('OL/views/Bet/Bet.vue');
const ComboBet = () => import('OL/views/ComboBet/ComboBet.vue');
const WeChatRegister = () => import('BASE/components/register/register.wechat.component.js');
const DrawHistory = () => import('OL/views/DrawHistory/DrawHistory.vue');
const AccountInfo = () => import('OL/views/AccountCenter/AccountInfo.vue');
const ProportionalDividend = () => import('OL/views/ProportionalDividend/ProportionalDividend.vue');
const Player = () => import('OL/views/Player/Player.vue');
const DailyPayManagement = () => import('OL/views/DailyPay/DailyPayManagement.vue');
const DailyPayManagementCG = () => import('OL/views/DailyPayCG/DailyPayManagement.vue');
const DailyRebateManagement = () => import('OL/views/DailyRebate/DailyRebateManagement.vue');
const DailyRebateSportManagement = () => import('OL/views/DailyRebateSport/DailyRebateManagement.vue');
const MyDailyPay = () => import('OL/views/DailyPay/MyDailyPay.vue');
const MyDailyPayCG = () => import('OL/views/DailyPayCG/MyDailyPay.vue');
const MyDailyRebate = () => import('OL/views/DailyRebate/MyDailyRebate.vue');
const MyDailyRebateSport = () => import('OL/views/DailyRebateSport/MyDailyRebate.vue');
const MyContract = () => import('OL/views/Dividend/MyContract.vue');
const MyContractExternalGame = () => import('OL/views/DividendExternalGame/MyContract.vue');
const DividendManagement = () => import('OL/views/Dividend/DividendManagement.vue');
const DividendExternalGameManagement = () => import('OL/views/DividendExternalGame/DividendManagement.vue');
const CreatePlayer = () => import('OL/views/Player/Player.Create.vue');
const RegisterLink = () => import('OL/views/RegisterLink/RegisterLink.vue');
const TradeAgreement = () => import('OL/views/TradeAgreement/TradeAgreement.vue');
const TradeAgreementCurrency = () => import('OL/views/TradeAgreement/TradeAgreement.Currency.vue');
const ExternalGameTrans = () => import('OL/views/ExternalGameTrans/ExternalGameTrans.vue');
const ExternalGameCardSubItem = () => import('OL/views/ExternalGame/ExternalGameCardSubItem.vue');
const ExternalGameFishSubItem = () => import('OL/views/ExternalGame/ExternalGameFishSubItem.vue');
const ExternalGameVideoLobby = () => import('OL/views/ExternalGame/ExternalGameVideoLobby.vue');
const ExternalGameSlotSubItem = () => import('OL/views/ExternalGame/ExternalGameSlotSubItem.vue');
const ExternalGameSportLobby = () => import('OL/views/ExternalGame/ExternalGameSportLobby.vue');
const ExternalGameFishLobby = () => import('OL/views/ExternalGame/ExternalGameFishLobby.vue');
const ExternalGameBlockchain = () => import('OL/views/ExternalGame/ExternalGameBlockchain.vue');
const WithdrawRequest = () => import('OL/views/WithdrawRequest/WithdrawRequest.vue');
const WithdrawRecord = () => import('OL/views/WithdrawRecord/WithdrawRecord.vue');
const ExternalGameTransRecord = () => import('OL/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const BetRecord = () => import('OL/views/BetRecord/BetRecord.vue');
const ScheduleRecord = () => import('OL/views/ScheduleRecord/ScheduleRecord.vue');
const CashFlowRecord = () => import('OL/views/CashFlowRecord/CashFlowRecord.vue');
const ActiveAccount = () => import('OL/views/ActiveAccount/ActiveAccount.vue');
const AccountSecurity = () => import('OL/views/AccountCenter/AccountSecurity.vue');
const AccountPassword = () => import('OL/views/AccountCenter/AccountPassword.vue');
const DrawLobby = () => import('OL/views/DrawLobby/DrawLobby.vue');
const ProfitReport = () => import('OL/views/ProfitReport/ProfitReport.Main.vue');
const Deposit = () => import('OL/views/Deposit/Deposit.vue');
const DepositQrcode = () => import('OL/views/Deposit/DepositQrcode.vue');
const DepositRecord = () => import('OL/views/DepositRecord/DepositRecord.vue');
const AwardDetail = () => import('OL/views/AwardDetail/AwardDetail.vue');
const Activity = () => import('OL/views/Activity/Activity.vue');
const OneDollarActivity = () => import('OL/views/Activity/OneDollarActivity.vue');
const DailyInterestActivity = () => import('OL/views/Activity/DailyInterest.vue');
const Coupon = () => import('OL/views/Coupon/Coupon.vue');
const FirstDepositByCategoryActivity = () => import('OL/views/Activity/FirstDepositByCategoryActivity.vue');
const DepositConsumeKENO2Activity = () => import('OL/views/Activity/DepositConsumeKENO2Activity.vue');
const DailySigninRedPackActivity = () => import('OL/views/Activity/DailySigninRedPackActivity.vue');
const RouletteActivity = () => import('OL/views/Activity/RouletteActivity.vue');
const NewbieQuestActivity = () => import('OL/views/Activity/NewbieQuestActivity.vue');
const RedPacketSolitaire = () => import('OL/views/Activity/RedPacketSolitaire.vue');
const LionKingContest = () => import('OL/views/Activity/LionKingContest.vue');
const BonusWallet = () => import('OL/views/AccountCenter/BonusWallet.vue');
const BlockChainHash = () => import('OL/views/BlockChainHash/BlockChainHash.vue');
const IFrame = () => import('OL/views/IFrame.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/Register', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/WeChatRegister/:code', name: 'WeChatRegister', component: WeChatRegister, meta: { ignoreAuth: true } },
        { path: '/DrawHistory/:id', name: 'DrawHistory', component: DrawHistory, meta: { ignoreAuth: true } },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode},
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        //以下是登入後須套用header、footer、chat的頁面
        {
            path: '/', component: Layout,
            children: [
                { path: '/', name: 'Home', component: Home },
                { path: '/Bet/:id', name: 'Bet', component: Bet },
                { path: '/ComboBet', name: 'ComboBet', component: ComboBet },
                { path: '/DownLoadCenterAndAFK', name: 'DownLoadCenterAndAFK', component: DownLoadCenterAndAFK },
                { path: '/AccountInfo', name: 'AccountInfo', component: AccountInfo },
                { path: '/Player', component: Player, meta: { isAgentAllow: true } },
                { path: '/ProportionalDividend', component: ProportionalDividend },
                { path: '/DailyPayManagement', component: DailyPayManagement, meta: { isAgentAllow: true } },
                { path: '/DailyPayManagementCG', component: DailyPayManagementCG, meta: { isAgentAllow: true } },
                { path: '/DailyRebateManagement', component: DailyRebateManagement, meta: { isAgentAllow: true } },
                { path: '/DailyRebateSportManagement', component: DailyRebateSportManagement, meta: { isAgentAllow: true } },
                { path: '/MyDailyPay', component: MyDailyPay },
                { path: '/MyDailyPayCG', component: MyDailyPayCG },
                { path: '/MyContract', component: MyContract },
                { path: '/MyContractExternalGame', component: MyContractExternalGame },
                { path: '/MyDailyRebate', component: MyDailyRebate },
                { path: '/MyDailyRebateSport', component: MyDailyRebateSport },
                { path: '/DividendManagement', component: DividendManagement, meta: { isAgentAllow: true } },
                { path: '/DividendExternalGameManagement', component: DividendExternalGameManagement, meta: { isAgentAllow: true } },
                { path: '/CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true } },
                { path: '/RegisterLink', component: RegisterLink, meta: { isAgentAllow: true } },
                { path: '/AwardDetail', name: 'AwardDetail', component: AwardDetail },
                { path: '/TradeAgreement', component: TradeAgreement },
                { path: '/TradeAgreementCurrency', component: TradeAgreementCurrency },
                { path: '/ExternalGameTrans', name: 'ExternalGameTrans', component: ExternalGameTrans },

                { path: '/ExternalGameCardSubItem/:gameType', name: 'ExternalGameCardSubItem', component: ExternalGameCardSubItem },
                { path: '/ExternalGameFishSubItem/:gameType', name: 'ExternalGameFishSubItem', component: ExternalGameFishSubItem },
                { path: '/ExternalGameVideoLobby/', name: 'ExternalGameVideoLobby', component: ExternalGameVideoLobby },
                { path: '/ExternalGameSlotSubItem/:gameType', name: 'ExternalGameSlotSubItem', component: ExternalGameSlotSubItem },
                { path: '/ExternalGameSportLobby/', name: 'ExternalGameSportLobby', component: ExternalGameSportLobby },
                { path: '/ExternalGameFishLobby/', name: 'ExternalGameFishLobby', component: ExternalGameFishLobby },
                { path: '/ExternalGameBlockchain/', name: 'ExternalGameBlockchain', component: ExternalGameBlockchain },
                { path: '/WithdrawRequest', name: 'WithdrawRequest', component: WithdrawRequest },
                { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord },

                { path: '/AccountSecurity', name: 'AccountSecurity', component: AccountSecurity },
                { path: '/AccountPassword', name: 'AccountPassword', component: AccountPassword },
                { path: '/BonusWallet', name: 'BonusWallet', component: BonusWallet },
                { path: '/ExternalGameTransRecord', name: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: '/BetRecord', name: 'BetRecord', component: BetRecord },
                { path: '/ScheduleRecord', name: 'ScheduleRecord', component: ScheduleRecord },
                { path: '/CashFlowRecord', name: 'CashFlowRecord', component: CashFlowRecord },
                { path: '/ActiveAccount', name: 'ActiveAccount', component: ActiveAccount, meta: { isAgentAllow: true } },
                { path: '/DrawLobby', name: 'DrawLobby', component: DrawLobby },
                { path: '/ProfitReport', name: 'ProfitReport', component: ProfitReport },
                { path: '/Deposit', name: 'Deposit', component: Deposit },
                { path: '/DepositRecord', name: 'DepositRecord', component: DepositRecord },
                { path: '/Activity', name: 'Activity', component: Activity },
                { path: '/OneDollarActivity', name: 'OneDollarActivity', component: OneDollarActivity },
                { path: '/DailyInterestActivity', name: 'DailyInterestActivity', component: DailyInterestActivity },
                { path: '/Coupon', name: 'Coupon', component: Coupon },
                { path: '/FirstDepositByCategoryActivity', name: 'FirstDepositByCategoryActivity', component: FirstDepositByCategoryActivity },
                { path: '/DepositConsumeKENO2Activity/:id', name: 'DepositConsumeKENO2Activity', component: DepositConsumeKENO2Activity },
                { path: '/DailySigninRedPackActivity', name: 'DailySigninRedPackActivity', component: DailySigninRedPackActivity },
                { path: '/RouletteActivity', name: 'RouletteActivity', component: RouletteActivity },
                { path: '/NewbieQuestActivity', name: 'NewbieQuestActivity', component: NewbieQuestActivity },
                { path: '/RedPacketSolitaire', name: 'RedPacketSolitaire', component: RedPacketSolitaire },
                { path: '/LionKingContest', name: 'LionKingContest', component: LionKingContest },
                { path: '/BlockChainHash', name: 'BlockChainHash', component: BlockChainHash },
                { path: '/IFrame', name: 'IFrame', component: IFrame },
            ]
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == "Login") {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some(record => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some(record => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }

        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        }
        else if (to.name === "Home" && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/Login');
        }
        else {
            next('/Timeout');   // 認證已過期
        }
    }
});

// 投注一般、旗艦版導向
router.afterEach(to => {
    if (to.meta.betClientTemplate) {
        storage.local.set(storage.keys.BET_CLIENT_TEMPLATE, to.meta.betClientTemplate);
    }
});

export default router;
